<template>
  <div class="student" v-loading="loading">
    <div class="wrap">
      <el-button
        type="defalut"
        class="normalBtn"
        size="small"
        @click="exportToExcel"
        >导出成绩</el-button
      >
      <el-progress
        :text-inside="true"
        :stroke-width="20"
        :percentage="progress"
        status="success"
      ></el-progress>
      <el-select v-model="sys_class_id" placeholder="请选择部门">
        <el-option key="" value="" label="全部"></el-option>
        <el-option
          v-for="item in classData"
          :key="item.sys_class_id"
          :label="item.sys_class_name"
          :value="item.sys_class_id"
        >
        </el-option>
      </el-select>
      <el-input
        placeholder="请输入手机号\姓名进行搜索"
        style="width:300px;margin-left:30px;"
        v-model="search"
      >
        <template slot="append">
          <el-button type="primary" size="small" @click="handleSearch"
            >搜索</el-button
          >
        </template>
      </el-input>
    </div>
    <h4 style="color:#29b084">{{ paper.title }}</h4>
    <el-table :data="tableData" style="width: 100%">
      <!-- <el-table-column label="ID"  align="center">
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>
      <el-table-column label="试卷ID"  align="center">
        <template slot-scope="scope">{{ scope.row.paper_id }}</template>
      </el-table-column>-->
      <el-table-column label="姓名" align="center" width="100">
        <template slot-scope="scope">{{ scope.row.user_name }}</template>
      </el-table-column>
      <el-table-column label="手机号" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.mobile }}</template>
      </el-table-column>
      <el-table-column label="部门" align="center" width="100">
        <span slot-scope="scope" v-if="scope.row.class_">{{
          scope.row.class_.sys_class_name
        }}</span>
        <span v-else>无</span>
      </el-table-column>
      <el-table-column label="得分" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.score }}</template>
      </el-table-column>
      <el-table-column label="单选正确率" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.radio_right }}</template>
      </el-table-column>
      <el-table-column label="多选正确率" width="90" align="center">
        <template class="brief" slot-scope="scope">{{
          scope.row.checkbox_right
        }}</template>
      </el-table-column>
      <el-table-column label="判断正确率" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.judgement_right }}</template>
      </el-table-column>
      <el-table-column label="填空正确率" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.cloze_right }}</template>
      </el-table-column>
      <el-table-column label="单选题得分" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.radio_score }}</template>
      </el-table-column>
      <el-table-column label="多选题得分" width="90" align="center">
        <template class="brief" slot-scope="scope">{{
          scope.row.checkbox_score
        }}</template>
      </el-table-column>
      <el-table-column label="判断题得分" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.judgement_score }}</template>
      </el-table-column>
      <el-table-column label="填空题得分" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.cloze_score }}</template>
      </el-table-column>
      <el-table-column label="答对题数" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.right_sum }}</template>
      </el-table-column>
      <el-table-column label="答错题数" width="90" align="center">
        <template class="brief" slot-scope="scope">{{
          scope.row.wrong_sum
        }}</template>
      </el-table-column>
      <el-table-column label="漏答题数" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.leakage_sum }}</template>
      </el-table-column>
      <el-table-column label="是否交卷" width="90" align="center">
        <template slot-scope="scope">
          <el-link type="danger" v-if="scope.row.status == 0">未交卷</el-link>
          <el-link type="warning" v-if="scope.row.status == 1">已交卷</el-link>
        </template>
      </el-table-column>
      <el-table-column label="查看试卷详情" align="center">
        <template slot-scope="scope">
          <el-link type="warning" @click="toDetail(scope.row)">查看</el-link>
        </template>
      </el-table-column>
      <el-table-column label="考试开始时间" width="150" align="center">
        <template slot-scope="scope">{{ scope.row.created_at }}</template>
      </el-table-column>
      <el-table-column label="考试结束时间" width="150" align="center">
        <template slot-scope="scope">{{ scope.row.updated_at }}</template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope" class="brief">
          <!-- <span class="check add" @click="link('examResult',scope.row.id)">查看详情</span> -->
          <!-- <span class="check add">查看详情</span> -->

          <el-link
            type="primary"
            @click="show(scope.row)"
            v-if="paper.is_verify == 1"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="认证未通过次数"
              placement="top"
            >
              <el-link
                type="danger"
                v-if="scope.row.verify_num - scope.row.verify_right != 0"
                >{{ scope.row.verify_num - scope.row.verify_right }}</el-link
              >
            </el-tooltip>
            <!-- <i class="el-icon-warning" style="color:red" v-if="scope.row.verify_num-scope.row.verify_right!=0"></i> -->
            认证详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total">
      <div class="pages-item">
        <p class="pages-text">
          每页显示{{ pageSize }} 条记录，共 {{ total }}条记录
        </p>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="pageSize"
        prev-text="上一页"
        next-text="下一页"
        layout="prev, pager, next"
        :total="total"
        class="pages-item"
      ></el-pagination>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="300px"
      :before-close="handleClose"
    >
      <span>导出成功！</span>
    </el-dialog>
    <el-drawer
      :title="title"
      :visible.sync="verify"
      direction="rtl"
      size="50%"
      v-loading="fullscreenLoading"
      element-loading-text="拼命加载中"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-row :gutter="0">
        <el-col :span="8" v-for="item in img_list" :key="item">
          <el-card class="box-card">
            <el-image :src="item.file"></el-image>
            <p>
              相似度：{{ item.score }}%
              <span class="red" v-if="item.score < 80">非本人</span>
            </p>
            <p class="time">拍摄时间：{{ item.created_at }}</p>
          </el-card>
        </el-col>
      </el-row>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: "PaperResult",
  data() {
    return {
      tableData: [{}],
      pageSize: 100,
      total: 0,
      search: "",
      sys_class_id: "",
      page: 1,
      progress: 0,
      dialogVisible: false,
      err_num: 1,
      type: 0,
      verify: false,
      img_list: [],
      title: "",
      fullscreenLoading: false,
      paper: [],
      loading: true,
      classData: [],
    };
  },
  created() {
    let _this = this;
    _this.getListData();
  },
  methods: {
    show(obj) {
      let id = this.$route.params.id;
      let _this = this;
      this.verify = true;
      this.title = obj.user_name + "-" + obj.mobile;
      let user_id = obj.user_id;
      this.fullscreenLoading = true;
      this.img_list = [];
      this.$http
        .post(process.env.VUE_APP_URL + "verifyimgs", {
          id: id,
          mem_id: user_id,
        })
        .then(function(data) {
          if (data.data.code == 200) {
            _this.img_list = data.data.data;
          }
          _this.fullscreenLoading = false;
        })
        .catch(function(error) {
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
    getListData() {
      let _this = this,
        id = this.$route.params.id;
      this.$http
        .post(process.env.VUE_APP_URL + "results", {
          id: id,
          page: this.page,
          search: this.search,
          sys_class_id: this.sys_class_id,
        })
        .then(function(data) {
          _this.loading = false;
          if (data.data.code == 200) {
            _this.tableData = data.data.data;
            // _this.tableData.forEach(item => {
            //   if (!!class_) {
            //     item.sys_class_name = item.class_.sys_class_name
            //   } else {
            //     item.sys_class_name = '无'
            //   }
            _this.classData = data.data.class;
            // })
            _this.type = data.data.type;
            _this.total = data.data.total;
            _this.paper = data.data.paper;
          } else {
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          _this.loading = false;

          return;
        });
    },
    link(path, id) {
      this.$router.push({ name: path, params: { id: id } });
    },

    toDetail(row) {
      this.$router.push({
        name: "examResult",
        params: {
          id: row.id,
        },
      });
    },
    handleCurrentChange(currentPage) {
      let _this = this;
      _this.page = currentPage;
      _this.getListData();
    },
    handleSearch() {
      this.page = 1;
      this.getListData();
    },
    exportToExcel() {
      //excel数据导出
      let _this = this,
        id = this.$route.params.id,
        page_count =
          Math.ceil(_this.total / 20) == 0 ? 1 : Math.ceil(_this.total / 20),
        success_count = 0,
        arr = [];
      _this.progress = 0;
      _this.err_num = 1;

      for (let i = 1; i <= page_count; i++) {
        let page = i;
        getData(id, page, 1);
      }
      function getData(id, page, num) {
        _this.$http
          .post(process.env.VUE_APP_URL + "results", {
            id: id,
            page: page,
            search: _this.search,
            sys_class_id: _this.sys_class_id,
          })
          .then(function(data) {
            if (data.data.code == 200) {
              // data.data.data.forEach(item => {
              //   item.score = Number(item.score)
              // })
              arr.push(...data.data.data);
              arr.forEach((item) => {
                if (item.class_) {
                  item.class_name = item.class_.sys_class_name;
                }
              });
              success_count++;
              _this.progress += Math.ceil((100 / page_count).toFixed(2));
              if (_this.progress >= 100) {
                _this.progress = 100;
              }
              if (success_count == page_count) {
                require.ensure([], () => {
                  const {
                    export_json_to_excel,
                  } = require("../js/Export2Excel");

                  const tHeader = [
                    "id",
                    "姓名",
                    "手机号",
                    "部门",
                    "得分",
                    "单选正确率",
                    "多选正确率",
                    "判断正确率",
                    "填空正确率",
                    "单选题得分",
                    "多选题得分",
                    "判断题得分",
                    "填空题得分",
                    "答对题数",
                    "答错题数",
                    "漏答题数",
                    "考试开放时间",
                    "考试结束时间",
                  ];

                  const filterVal = [
                    "user_id",
                    "user_name",
                    "mobile",
                    "class_name",
                    "score",
                    "radio_right",
                    "checkbox_right",
                    "judgement_right",
                    "cloze_right",
                    "radio_score",
                    "checkbox_score",
                    "judgement_score",
                    "cloze_score",
                    "right_sum",
                    "wrong_sum",
                    "leakage_sum",
                    "created_at",
                    "updated_at",
                  ];
                  let list = arr;
                  const a = _this.formatJson(filterVal, list);
                  export_json_to_excel(tHeader, a, "考试成绩");
                  //_this.dialogVisible = true;
                });
              }
            } else {
              let err_num = num;
              err_num++;
              if (err_num > 3) {
                _this.$message.error({ message: "导出失败，请稍后再试" });
                return;
              } else {
                getData(id, page, err_num);
              }
            }
          })
          .catch(function(error) {
            let err_num = num;
            err_num++;
            if (err_num > 3) {
              _this.$message.error({ message: "导出失败，请稍后再试" });
              return;
            } else {
              getData(id, page, err_num);
            }
          });
      }
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleClose() {
      this.progress = 0;
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.pages {
  padding: 10px;
  background-color: #f6f9fc;
  text-align: right;
  font-size: 14px;
  color: #606266;
  .pages-item {
    display: inline-block;
    vertical-align: middle;
  }
  .el-pagination {
    margin-left: 20px;
  }
}
.normalBtn {
  margin-bottom: 15px;
}
.time {
  font-size: 12px;
  color: #999;
}
.wrap {
  display: flex;
  justify-content: space-around;
  height: 50px;
  align-items: center;
}

.el-progress {
  width: 500px;
  margin-left: 20px;
}
.search-btn {
  width: 300px !important;
  margin-left: 30px;
}
.check {
  color: orange;
  cursor: pointer;
}
.box-card {
  margin: 10px;
}
/deep/.el-drawer__body {
  overflow: auto;
}

.red {
  color: #f00;
}
</style>
